<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Workshop Participants</h2>
<!--    {{ selectedFeedback }}-->
<!--    {{ dashboardInfo.user.id }}-->
<!--    {{ dashboardInfo.user.workshop }}-->
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white shadow-md mr-2" v-for="w in workshops" @click="selectWorkshop(w.wid)"
                :class="{'bg-theme-10': selectedIndex == w.wid, 'bg-theme-27': selectedIndex != w.wid}">
          {{ w.name }}
        </button>
        <div class="dropdown">
          <button
              class="dropdown-toggle button px-2 box text-gray-700 dark:text-gray-300"
          >
            <span class="w-5 h-5 flex items-center justify-center">
              <PlusIcon class="w-4 h-4"/>
            </span>
          </button>
          <div class="dropdown-box w-40">
            <div class="dropdown-box__content box dark:bg-dark-1 p-2">
              <a
                  href=""
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
              >
                <UsersIcon class="w-4 h-4 mr-2"/>
                Add Group
              </a>
              <a
                  href=""
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
              >
                <MessageCircleIcon class="w-4 h-4 mr-2"/>
                Send Message
              </a>
            </div>
          </div>
        </div>
        <div class="hidden md:block mx-auto text-gray-600">
          Showing {{ registrants.length }} entries
        </div>
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-56 relative text-gray-700 dark:text-gray-300">
            <input
                @input="search"
                type="text"
                class="input w-56 box pr-10 placeholder-theme-13"
                placeholder="Search..."
            />
            <SearchIcon
                class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
      </div>
      <!-- BEGIN: Users Layout -->
      <div class="col-span-12 text-center text-lg" v-if="workshops.length > 0 && selectedIndex == -1">
        Select a workshop!
      </div>
      <div
          v-for="(r, k) in registrants"
          :key="r.id"
          class="intro-y col-span-12 md:col-span-6"
      >
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center p-5">
            <div class="w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1">
              <!--              <img-->
              <!--                alt="Midone Tailwind HTML Admin Template"-->
              <!--                class="rounded-full"-->
              <!--                :src="require(`@/assets/images/${faker.photos[0]}`)"-->
              <!--              />-->
            </div>
            <div
                class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
            >
              <strong>{{ k + 1 }}# </strong>
              <a href="" class="font-medium">{{ r.name }}</a>
              <div class="text-gray-600 text-xs">{{ r.email }}</div>
            </div>
            <div class="flex mt-4 lg:mt-0">
              <button class="button button--sm text-white bg-theme-1 mr-2" @click="contact(r.email)">
                Message
              </button>
              <button class="button button--sm text-white bg-theme-1 mr-2" @click="feedbacks(r)">
                Feedbacks
              </button>
              <!--              <button-->
              <!--                class="button button&#45;&#45;sm text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-300"-->
              <!--              >-->
              <!--                Profile-->
              <!--              </button>-->
            </div>
          </div>
        </div>
      </div>
      <t-modal v-model="isModal">
        <comp-feedback :selected="selectedFeedback"></comp-feedback>
      </t-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import CompFeedback from "@/components/Core/UTrainerFeedback"

export default {
  components: {
    CompFeedback
  },
  data() {
    return {
      model: {},
      isModal: false,
      dashboardInfo: [],
      workshops: [],
      registrants: [],
      selectedIndex: -1,
      selectedFeedback: {
        model: {
          trainer_id: -1,
          wid: -1,
          uid: -1,
          rating: 5,
          feedback: "",
          meta: {effort: "", topic: "", focus: ""},
        },
        workshop: -1,
        user: -1
      },
      predata:
          {
            trainer_id: -1,
            wid: -1,
            uid: -1,
            rating: 5,
            feedback: "",
            meta: {effort: "", topic: "", focus: ""},
          },
      trainerSubmit: 'https://ucservice.upskill.com.bd/trainer/submit',
      trainerGet: 'https://ucservice.upskill.com.bd/trainer/get/trainer',
      trainerUpdate: 'https://ucservice.upskill.com.bd/trainer/update',
    }
  },
  methods: {
    feedbacks(r) {
      let w = this.workshops.find(o => this.selectedIndex == o.wid)
      let workshop = {id: w.wid, name: w.name}
      this.selectedFeedback.workshop = workshop
      this.selectedFeedback.user = r
      this.isModal = true
      let model = {...this.predata}
      this.model.wid = this.selectedFeedback.workshop
      this.model.uid = r.id
      this.model.rating = 0
      this.model.feedback = ""
      this.selectedFeedback.model = model
    },
    getProfileInfo() {
      this.$upskill.trainerDashboard().then(res => {
        this.dashboardInfo = res.data
        this.getKeys();
      });
    },
    getRegistrants(id) {
      this.$upskill.regs(id).then(res => {
        this.registrants = res.data.data || []
      })
    },
    selectWorkshop(id) {
      this.selectedIndex = id
      this.getRegistrants(id)
    },
    search(e) {

    },
    getKeys() {
      let arr = [];
      Object.keys(this.dashboardInfo.data).forEach(k => {
        arr.push({wid: k, name: this.dashboardInfo.data[k].name});
      });
      this.workshops = arr;
    },
    contact(email) {
      window.open("mailto:" + email, "_blank")
    }
  },
  created() {
    this.getProfileInfo()
  }
}
</script>
